import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IAuthResponse } from '../Interfaces';

const appSlicer = createSlice({
  name: 'userSlice',
  initialState: {
    username: '',
    fullname: '',
    isLoggedIn: false,
    role: '',
    token: ''
  },

  reducers: {
    signIn(state, action: PayloadAction<IAuthResponse | null>) {
      if (action.payload !== null) {
        //console.log(action.payload)
        state.username = action.payload.username;
        state.fullname = action.payload.fullname;
        state.role = action.payload.role;
        state.token = action.payload.token;
        state.isLoggedIn = true;
      }
    },
    signOut(state) {
      state.username = '';
      state.fullname = '';
      state.token = '';
      state.role = '';
      state.isLoggedIn = false
    }

  }
})

export const { signIn, signOut } = appSlicer.actions

export default appSlicer.reducer